


import React from "react";

const Pagination = ()=>{
    return (
            <div className="pagesBtn">
                {/* <button className="back">Previous</button>
                <button className="next"
                   >Next</button> */}
            </div>
    )
}
// onClick={fetchImages}
export default Pagination